import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	severity: string | null;
	alarmNodeType: string | null;
	alarmMask: boolean | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	searchValue: '',
	sortDirection: true,
	sortFieldName: 'alarmIndex',
	severity: null,
	alarmNodeType: null,
	alarmMask: null,
};

const alarmManagementFlexidas = createSlice({
	name: 'alarmManagementFlexidas',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setSeverity: (state, action: PayloadAction<{ severity: string | null }>) => {
			state.severity = action.payload.severity;
			state.page = initialState.page;
		},
		setAlarmNodeType: (state, action: PayloadAction<{ alarmNodeType: string | null }>) => {
			state.alarmNodeType = action.payload.alarmNodeType;
			state.page = initialState.page;
		},
		setAlarmMask: (state, action: PayloadAction<{ alarmMask: boolean | null }>) => {
			state.alarmMask = action.payload.alarmMask;
			state.page = initialState.page;
		},
		resetAlarmManagementTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSearchValue,
	setSort,
	setSeverity,
	setAlarmNodeType,
	setAlarmMask,
} = alarmManagementFlexidas.actions;

export default alarmManagementFlexidas.reducer;
